import { SummerAppFieldTypesEnum } from 'app/shared/enums/field-types.enum';
import { QuestionBaseModel } from './question-base.model';
export class LabelQuestionModel extends QuestionBaseModel<boolean> {
    
        fieldTypeName = SummerAppFieldTypesEnum.Label;
    
        constructor(options: {} = {}) {
          super(options);
          this.value=options['label'];
        }
      }


// WEBPACK FOOTER //
// ./src/app/shared/models/label-question.model.ts